import type { ComponentPropsWithoutRef } from 'react';
import { Error } from './Error';
import { RowsError } from './RowError';

type Props = Pick<
  ComponentPropsWithoutRef<typeof RowsError>,
  'onRangeClick'
> & {
  error: string;
  errorRowRanges: number[][];
  onDismiss: () => void;
};

export const AnalysisError = ({
  error,
  errorRowRanges,
  onDismiss,
  onRangeClick,
}: Props) => {
  return (
    <Error onDismiss={onDismiss}>
      <RowsError
        message={error}
        errorType="analysis"
        ranges={errorRowRanges}
        onRangeClick={onRangeClick}
      />
    </Error>
  );
};
